export enum EventTypeCategory {
  Study = 1,
  Site = 2,
  Country = 3,
  Default = 7, // TODO: check
}
